<template>
  <div class="invoice-tax-rate-add">
    <breadcrumb :breadcrumb="breadcrumb" />
    <text-title :mainTitle="mainTitle" :subheading="subheading" />
    <form>
      <div class="form-line">
        <div class="textBox">
          <b class="red">*</b>
          <span class="line-text">计划名称：</span>
        </div>
        <el-input v-model="formData.planName" size="small" style="width: 280px" />
      </div>

      <div class="form-line">
        <div class="textBox">
          <b class="red">*</b>
          <span class="line-text">巡检类目：</span>
        </div>
        <el-select v-model="formData.deviceCategoryCode" size="small" style="width: 280px">
          <el-option v-for="item in categoryList" :key="item.code"
                     :label="item.name" :value="item.code">
          </el-option>
        </el-select>
      </div>

      <div class="form-line">
        <div class="textBox">
          <b class="red">*</b>
          <span class="line-text">班组：</span>
        </div>
        <el-select v-model="formData.teamCode" size="small" style="width: 280px">
          <el-option v-for="item in teamList" :key="item.code"
                     :label="item.teamName" :value="item.code">
          </el-option>
        </el-select>
      </div>

      <div class="form-line">
        <div class="textBox">
          <b class="red">*</b>
          <span class="line-text">巡检周期：</span>
        </div>
        <el-select v-model="formData.inspectionCycle" size="small" style="width: 280px">
          <el-option v-for="item in inspectionCycleList" :key="item.code"
                     :label="item.name" :value="item.code">
          </el-option>
        </el-select>
      </div>

      <div class="form-line" v-if="formData.inspectionCycle === '5'">
        <div class="textBox">
          <b class="red">*</b>
          <span class="line-text">自定义日期：</span>
        </div>
        <div>
          <div v-for="(item, index) in customDateList" :key="index" style="margin-bottom: 10px;">
            <el-date-picker v-model="item.date" type="date" value-format="yyyy-MM-dd" placeholder="请选择" size="small" style="width: 280px"></el-date-picker>
            <i class="el-icon-remove-outline" style="line-height: 32px;font-size: 18px;color: #f25721;margin: 0 0 0 10px;cursor: pointer;" @click="removeCustomDateItem(index)" v-if="index > 0"></i>
            <i class="el-icon-circle-plus-outline" style="line-height: 32px;font-size: 18px;color: #00A0E6;margin: 0 10px 0 10px;cursor: pointer;" @click="addCustomDateItem(index)" v-if="index === customDateList.length - 1"></i>
          </div>
        </div>
      </div>

      <div class="form-line">
        <div class="textBox">
          <b class="red">*</b>
          <span class="line-text">巡检内容：</span>
        </div>
        <el-input v-model="formData.inspectionContent" type="textarea" :rows="3" size="small" style="width: 280px" />
      </div>

      <div class="form-btn-box">
        <button-confirm @confirm="confirm" />
        <button-cancel @cancel="cancel" />
      </div>
    </form>
  </div>
</template>

<script>
import Breadcrumb from '../../../components/Breadcrumb/Breadcrumb'
import TextTitle from '../../../components/Text/TextTitle'
import ButtonConfirm from '../../../components/Button/ButtonConfirm'
import ButtonCancel from '../../../components/Button/ButtonCancel'
import {getObjectURL} from '../../../utils/toBase64'
import $ from 'jquery'
import {api} from '../../api/Inspection'
import {nError, nSuccess} from '../../../utils/notice'
import {errorHandler} from '../../../utils/errorHandler'

export default {
  components: {
    ButtonCancel,
    ButtonConfirm,
    TextTitle,
    Breadcrumb},
  name: 'inspection-plan-add',
  data () {
    return {
      breadcrumb: [{
        value: '智慧巡检',
        name: 'inspection-device-type-manage'
      }, {
        value: '巡检计划'
      }],
      mainTitle: '修改巡检计划',
      subheading: '',

      categoryList: [],
      teamList: [],
      inspectionCycleList: [
        {
          code: '1',
          name: '日计划'
        }, {
          code: '2',
          name: '周计划'
        }, {
          code: '3',
          name: '月计划'
        }, {
          code: '4',
          name: '季计划'
        }, {
          code: '5',
          name: '自定义'
        }
      ],
      customDateList: [
        {
          date: ''
        }
      ],
      formData: {
        planName: '',
        deviceCategoryCode: '',
        deviceCategoryName: '',
        inspectionContent: '',
        inspectionCycle: '',
        teamCode: '',
        teamName: '',
        dateList: [],
      },

    }
  },
  created () {
    this.getInspectDeviceTypeList()
    this.getInspectTeamList()
    this.getInspectPlanByCode()
  },
  methods: {
    // 获取巡检类目
    getInspectDeviceTypeList () {
      this.$axios.get(api.getInspectDeviceTypeList, {})
        .then(res => {
          let list = res.data.data
          this.categoryList = list
        })
        .catch(errorHandler('获取巡检类目失败'))
    },
    // 获取班组列表
    getInspectTeamList () {
      this.$axios.get(api.getInspectTeamList, {})
        .then(res => {
          let list = res.data.data
          this.teamList = list
        })
        .catch(errorHandler('获取班组失败'))
    },

    // 获取计划详情
    getInspectPlanByCode () {
      this.$axios.get(`${api.getInspectPlanByCode}/${this.$route.params.id}`, {})
        .then(res => {
          let data = res.data.data
          this.formData = data
          if (this.formData.dateList) {
            if (this.formData.dateList.length > 0) {
              let customDateList = []
              this.formData.dateList.map(v => {
                let obj = {
                  date: v
                }
                customDateList.push(obj)
              })
              this.customDateList = customDateList
              console.log(this.customDateList)
            }
          }
        })
        .catch(errorHandler('获取详情失败'))
    },

    // 增加班组人员
    addCustomDateItem (index) {
      if (!this.customDateList[index].date) {
        nError('请先选择当前时间')
        return false
      }
      let obj = {
        date: ''
      }
      this.customDateList.push(obj)
    },

    // 删减班组人员
    removeCustomDateItem (index) {
      this.customDateList.splice(index, 1)
    },

    toManagePage () {
      this.$router.push({
        name: 'inspection-plan-manage'
      })
    },

    confirm () {
      if (!this.formData.planName) {
        nError('请输入计划名称')
        return false
      }
      if (!this.formData.deviceCategoryCode) {
        nError('请选择巡检类目')
        return false
      }
      if (!this.formData.teamCode) {
        nError('请选择巡检班组')
        return false
      }
      if (!this.formData.inspectionCycle) {
        nError('请选择巡检周期')
        return false
      }
      if (!this.formData.inspectionContent) {
        nError('请输入巡检内容')
        return false
      }
      this.categoryList.map(v => {
        if (this.formData.deviceCategoryCode === v.code) {
          this.formData.deviceCategoryName = v.name
        }
      })
      this.teamList.map(v => {
        if (this.formData.teamCode === v.code) {
          this.formData.teamName = v.teamName
        }
      })
      if (this.formData.inspectionCycle === '5') {
        if (!this.customDateList[0].date) {
          nError('请选择自定义日期')
          return false
        }
        let dateList = []
        this.customDateList.map(v => {
          dateList.push(v.date)
        })
        this.formData.dateList = dateList
      }
      this.$axios.post(api.updateInspectPlan, this.formData)
        .then(res => {
          if (res.data.retCode === 1) {
            nSuccess('修改成功')
            this.toManagePage()
          }
        })
        .catch(errorHandler('修改失败'))
    },
    cancel () {
      this.toManagePage()
    }
  },
}
</script>

<style scoped>
form {
  width: 80%;
  margin: 0 auto;
  text-align: left;
}
.red {
  color: #FF0000;
  vertical-align: sub;
}
.form-line {
  margin: 20px 0;
  display: flex;
  justify-content: flex-start;
  align-items: flex-start;
}
.form-line>div {
  margin-right: 20px;
}
.line-text{
  color: #48576a;
  font-size: 14px;
  margin-right: 10px;
}
.textBox {
  display: inline-block;
  width: 122px;
  line-height: 32px;
  text-align: right;
}
.form-btn-box {
  width: 530px;
  padding: 0 110px 0 140px;
  margin: 40px 0 0 0;
  display: flex;
  justify-content: space-between;
}
.newly2 {
  display: inline-block;
  width: 80px;
  height: 80px;
  vertical-align: text-top;
  border: 1px dashed #D7D7D7;
  margin-right: 20px;
  position: relative;
}
.newly2 span {
  display: block;
  width: 100%;
  color: #999999;
  margin: 0;
  padding: 0;
  text-align: center;
}
.newly2 span:first-child {
  font-size: 28px;
  line-height: 40px;
  position: absolute;
  top: 15px;
}
.newly2 span:last-child {
  font-size: 14px;
  line-height: 20px;
  position: absolute;
  bottom: 0;
}
.upload2 {
  display: inline-block;
  width: 80px;
  height: 80px;
  vertical-align: text-top;
  background-size: 100% 100%;
  position: relative;
}

.upload2 img {
  width: 100%;
  height: 100%;
  border-radius: 5px;
}
.upload2 b {
  display: inline-block;
  width: 100%;
  line-height: 21px;
  color: white;
  background-color: #989796;
  text-align: center;
  position: absolute;
  bottom: 0;
  opacity: .7;
}
</style>

<style lang="less">
.invoice-tax-rate-add {
  .el-switch {
    height: 30px;
  }
  .el-input-number.is-controls-right .el-input__inner {
    text-align: left;
  }
}
</style>




// WEBPACK FOOTER //
// src/view/Inspection/InspectionPlan/InspectionPlanModify.vue